import type { WeeklyBreakdownDTO } from "../models/weeklyBreakdownDto";
import type { WeeklyBreakdownEntity } from "../../domain/entities/WeeklyBreakdownEntity";

export function weeklyBreakdownDtoToEntity(dto: WeeklyBreakdownDTO): WeeklyBreakdownEntity {
  return {
    weeks: (dto.weeks ?? []).map((w) => ({
      id: w.id,
      label: w.label,
      startDate: w.startDate,
      endDate: w.endDate,
      weekLabel: w.weekLabel,
      weekSubtext: w.weekSubtext,
      revenue: Number(w.revenue) || 0,
      collected: Number(w.collected) || 0,
      out: Number(w.out) || 0,
      cash: Number(w.cash) || 0,
      summaryBullets: w.summaryBullets ?? [],
    })),
  };
}

